import * as React from "react";
import {
  OriginThemeProvider,
  TrackingProvider,
} from "@origin-digital/ods-core";
import { trackingProviderCaptureClick } from "@origin-digital/reporting-client";
import { BrowserRouter } from "react-router-dom";
import { AppContextProvider } from "./AppContext";
import { Router } from "./router";

export default (config: { envConfig: IAppConfig }) => {
  return (
    <OriginThemeProvider>
      <TrackingProvider onTrackingCapture={trackingProviderCaptureClick}>
        <AppContextProvider config={config.envConfig}>
          <BrowserRouter>
            <Router />
          </BrowserRouter>
        </AppContextProvider>
      </TrackingProvider>
    </OriginThemeProvider>
  );
};
